<template>
	<div class="image-uploader" :class="[(uploading) ? 'uploading' : '', input.class]">
		<div class="overlay">
			<img class="spinner" src="/images/spinner.gif" />
		</div>
		<img class="preview-image" v-if="image" :src="value" />
		<input type="file" ref="imageInput" @change="previewImage" accept="image/*" />
		<span class="price" v-if="option.input.price > 0" v-text="formatPrice(option.input.price)"></span>
		<button v-if="image" @click="deleteImage">Delete Image</button>
	</div>
</template>

<script>
import firebase from "../../firebase/init";
import InputBase from "./InputBase";
import helper from "@/mixins/helper.js";

export default {
	name: "InputImageUpload",
	extends: InputBase,
	props: ["option"],
	mixins: [helper],
	data() {
		return {
			image: null,
			value: null,
			uploading: false
		};
	},
	created() {
		// Save default validation status to store
		this.updateValidationStatus(this.option, this.value);
	},
	methods: {
		previewImage: function(event) {
			// Reference to the DOM input element
			var input = event.target;
			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {
				// create a new FileReader to read this image and convert to base64 format
				this.image = input.files[0];
				var reader = new FileReader();
				// Define a callback function to run, when FileReader finishes its job
				reader.onload = e => {
					// Note: arrow function used here, so that "this.value" refers to the value of Vue component
					// Read image as base64 and set to value
					this.value = e.target.result;
					this.updateStore();
					this.updateValidationStatus(this.option, this.value);
				};
				// Start the reader job - read file as a data url (base64 format)
				reader.readAsDataURL(input.files[0]);
			}
		},
		/**
		 * Method not used currently
		 */
		uploadImage() {
			if (this.image) {
				const imageRef = firebase.ref().child("seabags/" + this.image.name);
				this.uploading = true;

				imageRef
					.put(this.image)
					.then(snapshot => {
						console.log("Image Uploaded!");
					})
					.catch(error => {
						console.log("Image upload FAILED: " + error.message);
					})
					.finally(() => {
						this.uploading = false;
					});
			} else {
				console.log("No image selected!");
			}
		},
		deleteImage() {
			this.image = null;
			this.value = "";
			this.$refs.imageInput.value = null;
			this.updateStore();
			this.updateValidationStatus(this.option, this.value);
		},
		updateStore() {
			this.setSelectedOptionToStore(this.option.input.name, {
				name: this.image ? this.option.name + ": " + this.image.name : this.option.name,
				position: this.option.position,
				sku: this.option.sku,
				price: this.value.length > 0 ? this.option.input.price : 0,
				value: this.image ? this.image.name : "",
				previewValue: this.value,
				previewMutations: this.option.previewMutations
			});
		}
	}
};
</script>

<style lang="scss" >
.seabags {
	.image-uploader {
		position: relative;

		.overlay {
			display: none;
		}
		&.uploading {
			.overlay {
				display: block;
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				background: rgba(0, 0, 0, 0.3);
			}
		}
		.preview-image {
			max-width: 150px;
		}
	}
}
</style>